const exp = new Date().getFullYear() - 2022;

const aboutMe = {
  experience: exp + "+ Years Working",
  text: [
    `${exp}+ years of experience in front-end web development.`,
    "Proficient in React.js and Next.js.",
    "Strong understanding of the web development lifecycle process.",
    "Skilled in creating visually appealing layouts and dashboards.",
    "Familiarity with design software like Figma.",
  ],
};

export default aboutMe;
